import { FC, ReactNode } from 'react';
import { Alert, AlertTitle, Snackbar, SnackbarProps } from '@mui/material';
import { NotificationSeverity } from '@vs-online-only-app/state';

interface Props extends SnackbarProps {
  handleClose?: () => void;
  severity: NotificationSeverity;
  title?: string;
  message: ReactNode;
}

const SnackAlert: FC<Props> = ({
  handleClose,
  key,
  severity,
  title,
  message,
  action,
  ...rest
}) => (
  <Snackbar
    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    autoHideDuration={4000}
    onClose={handleClose}
    {...rest}
  >
    <Alert
      severity={severity}
      sx={{ alignItems: 'center', border: '1px solid' }}
    >
      {title && <AlertTitle>{title}</AlertTitle>}
      {message}
    </Alert>
  </Snackbar>
);

export default SnackAlert;
